import React from 'react'
import Page from 'contexts/page'
import DocumentsProvider from 'contexts/documents'
import Routing from './routing'

const DocumentsPage = ({ upgradable }) => (
    <Page
        view="documents"
        title={{
            id: 'documents_heading',
            defaultMessage: 'Documents'
        }}
        upgrade={{
            enabled: upgradable,
            passthrough: true
        }}>
        <DocumentsProvider
            fetchAccess={!upgradable}
            fetchOnMount={false}
            sortCacheKey="list:documents:global:sort"
            selectable>
            <Routing upgradable={upgradable} />
        </DocumentsProvider>
    </Page>
)

export default DocumentsPage